
<div v-if="validAverage" class="star-rating" :aria-label="ariaLabelForRatings" role="img">
  <span v-for="index in fullStarCount" :key="index" class="star-rating__star icon-star_filled"></span>

  <span v-if="!fullStarMaxedOut">
    <span v-if="!isAverageWholeNumber">
      <span v-if="hasHalfStar" class="star-rating__star icon-star_half"></span>
      <span v-else class="star-rating__star icon-star_filled"></span>
    </span>

    <span v-for="index in emptyStarCount" :key="index" class="star-rating__star icon-star_empty"></span>
  </span>
  <span v-if="showCount" class="star-rating__count">({{ count }})</span>
</div>
